import { useState, useEffect } from 'react';
import './App.css';
import './index.css';
// 1. Keep your Router import
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Loader from './Loader'; 

import Homepage from './Home';
import Loginpage from './Login';
import Registpage from './Regist';
import Landingpage from './Landing/Landingpage';
import About from './Landing/About';
import Contact from './Landing/Contact';
import AdminDash from './Landing/AdminDash';
import Logout from './Landing/Logout';
import ServiceManagement from './Landing/UpdateService';
import SurveyorDashboard from './Landing/SurveyorDash';
import Resources from './Resources';
import HelpPage from './Help';
import Partners from './Partners'; 
import PrivacyPolicy from './PrivacyPolicy';
import BookingPage from './Landing/BookingPage';
import PageNotFound from './404page';
import RequestProgress from './Landing/RequestProgress';
import NProgress from 'nprogress';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import UserProfile from './Landing/UserProfile';

NProgress.configure({SpinLoader: false});

function RouterTrack(){
  const location = useLocation();
  NProgress.start();
  useEffect(() => {
const timer = setTimeout(() => {
    NProgress.done();
  },200);

  return () => clearTimeout(timer);
  },[location.pathname])

  return null;
}

function App() {
  const [isConnecting, setIsConnecting] = useState(false);

  // useEffect(() => {
  //   const handleOnline = () => {
  //     setTimeout(() => setIsConnecting(false), 500);
  //   };

  //   const handleOffline = () => {
  //     setIsConnecting(true);
  //   };

  //   window.addEventListener('online', handleOnline);
  //   window.addEventListener('offline', handleOffline);

  //   if (navigator.onLine) {
  //     setIsConnecting(false);
  //   }

  //   return () => {
  //     window.removeEventListener('online', handleOnline);
  //     window.removeEventListener('offline', handleOffline);
  //   };
  // }, []);

  return (
    // 2. Wrap EVERYTHING in the Router first so useNavigate() is always safe to call
    <Router>
      <RouterTrack />
      <div className="App">
        {isConnecting ? (
          <Loader message="Establish Your Internet Connection" />
        ) : (
          <Routes>
            <Route path='/' element={<Homepage />}></Route>
            <Route path='/login' element={<Loginpage /> }></Route>
            <Route path='/explore' element={<Resources /> }></Route>
            <Route path='/regist' element={<Registpage /> }></Route>
            <Route path='/Landing' element={<Landingpage /> }></Route>
            <Route path='/about' element={<About /> }></Route>
            <Route path='/contact' element={<Contact /> }></Route>
            <Route path='/AdminDash' element={<AdminDash />}></Route>
            <Route path='/update' element={<ServiceManagement />}></Route>
            <Route path='/booking/:id' element={<BookingPage />}></Route>
            <Route path='/Surveyordashboard' element={<SurveyorDashboard />}></Route>
            <Route path='/help' element={<HelpPage />}></Route>
            <Route path='/partners' element={<Partners />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
            <Route path='/progress' element={<RequestProgress />} />
             <Route path='/profile' element={<UserProfile />} />
            <Route path='/resetPassword/:token' element={<ResetPassword />} />
            <Route path='/forgotPassword' element={<ForgotPassword />} />
            <Route path='/logout' element={<Logout />}></Route>
            <Route path='*' element={<PageNotFound />}></Route>
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;